import * as React from 'react';
import { childClassClosure, ClassableProps, baseClassAnd } from "@jcharlesworthuk/your-mum-core/dist/functions";
import './NiceTextareaField.scss';
import { InputChangeDelegate } from '../../helpers/InputDelegates';

const baseClass = 'nice-textarea-field';
const childClass = childClassClosure(baseClass);


type Props = ClassableProps & {
  label: string;
  fullWidth?: boolean;
  value: string;
  error?: boolean;
  onChange: InputChangeDelegate;
  disabled?: boolean;
  isOptional?: boolean;
  placeholder?: string;
}

const NiceTextareaField: React.FunctionComponent<Props> = props => {
  const fieldName = props.label.replace(' ', '');
  const validationClass = props.error === true && props.isOptional != true ? 'invalid' : '';

  return <div className={baseClassAnd(baseClass, props)}>
    <label htmlFor={fieldName}>{props.label} {props.isOptional == true ? <small>(optional)</small> : ''}</label>
    <div className={childClass('control-wrapper', validationClass)}>
      <textarea rows={5}
        className={childClass('input', validationClass)}
        onChange={props.onChange}
        value={props.value}
        name={fieldName}
        required={!props.isOptional}
        disabled={!!props.disabled}
        placeholder={props.placeholder} />
    </div>
  </div>
}

export default NiceTextareaField;